// Caixa de entrada do DF-e (BDM-1038).

export const DFE_STATUS_OPTIONS = [
    { label: 'Pendentes e triadas', value: '' },
    { label: 'Pendentes', value: 'pending' },
    { label: 'Importadas', value: 'imported' },
    { label: 'Já lançadas', value: 'expense' },
    { label: 'Ignoradas', value: 'ignored' },
];

export const getDfeStatusLabel = invoice => {
    if (invoice?.provider_status === 'CANCELADO') return 'Cancelada';
    if (invoice?.provider_status === 'DENEGADO') return 'Denegada';

    return {
        pending: 'Pendente',
        imported: 'Importada',
        expense: 'Já lançada',
        ignored: 'Ignorada',
    }[invoice?.status] ?? '—';
};

export const getEmitterLabel = invoice =>
    invoice?.emitter_trade_name || invoice?.emitter_name || invoice?.emitter_cnpj || '—';

/**
 * Sem manifestação a SEFAZ entrega só o resumo. A ciência que libera o XML
 * completo é automática, mas vale 10 dias da autorização — depois disso só a
 * manifestação conclusiva, que é decisão do cliente.
 */
export const getXmlNotice = invoice => {
    if (invoice?.full_xml) return null;

    return invoice?.can_manifest_for_full_xml
        ? 'A SEFAZ não liberou os itens: o prazo da ciência automática (10 dias) passou.'
        : 'Só o resumo por enquanto. Os itens costumam ser liberados em alguns minutos.';
};
